import type { Model } from '@patsnap/tahiti-core';
import type { SpecificationGenContentState } from '../types/specification-gen-content';

export const SpecificationGenContentModel = Symbol.for('SpecificationGenContentModel');

export interface SpecificationGenContentModel extends Model<SpecificationGenContentState> {}
